var _g, _circle, _circle2, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 154,
    viewBox: "0 0 211 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_139_22266)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.85 65.301C156.375 40.2705 134.89 21 108.903 21C86.1863 21 66.9091 35.7261 60.0967 56.1528C59.6913 56.1385 59.284 56.1313 58.8751 56.1313C40.092 56.1313 24.8653 71.358 24.8653 90.1411C24.8653 108.515 39.4361 123.486 57.6533 124.129V124.151H152.248V123.977C153.349 124.101 154.468 124.165 155.602 124.165C171.94 124.165 185.185 110.92 185.185 94.5816C185.185 79.6856 174.175 67.361 159.85 65.301Z",
    fill: "url(#paint0_linear_139_22266)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.902,
    cy: 72.4375,
    r: 51.4375,
    fill: "url(#paint1_linear_139_22266)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.601,
    cy: 94.5817,
    r: 29.5834,
    fill: "url(#paint2_linear_139_22266)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_139_22266)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 105.025,
    cy: 79.8648,
    r: 25.3573,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.025 54.5072C100.01 54.5072 95.1076 55.9944 90.9376 58.7807C86.7676 61.567 83.5174 65.5273 81.5982 70.1608C79.679 74.7942 79.1768 79.8928 80.1552 84.8116C81.1336 89.7305 83.5487 94.2487 87.095 97.795C90.6413 101.341 95.1596 103.756 100.078 104.735C104.997 105.713 110.096 105.211 114.729 103.292C119.363 101.373 123.323 98.1225 126.109 93.9525C128.896 89.7825 130.383 84.8799 130.383 79.8646C130.375 73.1418 127.701 66.6964 122.947 61.9426C118.194 57.1888 111.748 54.5148 105.025 54.5072ZM103.075 68.1612C103.075 67.6439 103.28 67.1477 103.646 66.7819C104.012 66.4161 104.508 66.2106 105.025 66.2106C105.543 66.2106 106.039 66.4161 106.405 66.7819C106.77 67.1477 106.976 67.6439 106.976 68.1612V81.8152C106.976 82.3325 106.77 82.8287 106.405 83.1945C106.039 83.5603 105.543 83.7658 105.025 83.7658C104.508 83.7658 104.012 83.5603 103.646 83.1945C103.28 82.8287 103.075 82.3325 103.075 81.8152V68.1612ZM105.025 93.5186C104.447 93.5186 103.881 93.347 103.4 93.0255C102.919 92.704 102.544 92.2471 102.322 91.7125C102.101 91.1778 102.043 90.5895 102.156 90.022C102.269 89.4544 102.547 88.9331 102.957 88.5239C103.366 88.1147 103.887 87.836 104.455 87.7231C105.022 87.6102 105.61 87.6682 106.145 87.8896C106.68 88.1111 107.137 88.4861 107.458 88.9673C107.78 89.4484 107.951 90.0141 107.951 90.5928C107.951 91.3688 107.643 92.113 107.094 92.6617C106.546 93.2104 105.801 93.5186 105.025 93.5186Z",
    fill: "#F27DB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6488 32.4928L41.1435 44.8711",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5853 40.9346L37.207 36.4293",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0633 30.5069L21.3735 37.8968",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4134 35.5467L19.0234 32.857",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8478 50.0564L22.5517 59.1122",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7276 56.2323L19.6719 52.9363",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164.351 32.4928L168.856 44.8711",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.415 40.9346L172.793 36.4293",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.937 30.5069L188.626 37.8969",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.587 35.5468L190.977 32.8571",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.152 50.0565L187.448 59.1122",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181.272 56.2324L190.328 52.9363",
    stroke: "#E2E8F0",
    strokeWidth: 1.03494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_139_22266",
    x: 0.0265694,
    y: 0.301113,
    width: 209.998,
    height: 152.842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.13978
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.4193
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.145098 0 0 0 0 0.160784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_22266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_22266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_139_22266",
    x: 61.6321,
    y: 36.4715,
    width: 86.7866,
    height: 86.7865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.01795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.490196 0 0 0 0 0.705882 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_22266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_22266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_22266",
    x1: 204.506,
    y1: 124.165,
    x2: 4.96538,
    y2: 58.7385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_139_22266",
    x1: 60.8267,
    y1: 21,
    x2: 108.902,
    y2: 72.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_139_22266",
    x1: 139.378,
    y1: 69.5454,
    x2: 155.601,
    y2: 94.5817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b357c63b7166d3b24a8accfac644984a.svg";
export { ForwardRef as ReactComponent };